import { Api } from "@/api/axios";

export default class UserApi extends Api {
  constructor(baseUrl, usersEndpointUrl) {
    super();
    this.usersEndpointUrl = baseUrl + usersEndpointUrl;
    this.createUser = this.createUser.bind(this);
    this.updateUser = this.updateUser.bind(this);
  }

  createUserFromResource(resource) {
    // Spread first: this mapper used to list fields explicitly, which silently
    // dropped everything else the API returned. After an update that wiped
    // `genres` off the user and re-triggered the genre onboarding modal.
    return {
      ...resource,
      id: resource.id,
      name: resource.name,
      email: resource.email,
      createdAt: resource.createdAt,
      updatedAt: resource.updatedAt,
      verified: resource.verified,
      roles: resource.roles,
      genres: resource.genres ?? null,
      locale: resource.locale ?? null,
      subscription: resource.subscription ?? null,
      notifications: resource.notifications ?? null,
    };
  }

  /**
   * Create a user.
   */
  createUser(name, email, teamId) {
    return this.post(this.usersEndpointUrl, {
      name: name,
      email: email,
      teamId: teamId,
    })
      .then((response) => this.createUserFromResource(response.data))
      .catch((error) => {
        throw error;
      });
  }

  /**
   * Updates and returns the specified user.
   */
  updateUser(userId, data) {
    return this.post(this.usersEndpointUrl + "/" + userId, data, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
      .then((response) => this.createUserFromResource(response.data))
      .catch((error) => {
        throw error;
      });
  }

  /**
   * Deletes the user from the system.
   */
  deleteUser(userId) {
    return this.delete(this.usersEndpointUrl + "/" + userId)
      .then(() => undefined)
      .catch((error) => {
        throw error;
      });
  }

  /**
   * Returns all users without a team.
   */
  getUsersWithoutTeam() {
    return this.get(this.usersEndpointUrl)
      .then((response) => response.data)
      .catch((error) => {
        throw error;
      });
  }
}
